import type React from 'react';

export const iconBtnStyle: React.CSSProperties = {
  background: 'none', border: 'none', cursor: 'pointer', padding: 3, borderRadius: 4,
  color: 'var(--nj-semantic-color-text-secondary-default)',
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
};

export function formatCommentDate(isoString: string): string {
  return new Date(isoString).toLocaleString('fr-FR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}
